import Vue from 'vue'
import VueRouter from 'vue-router'
import pcHeader from '@/components/header'
import pcFooter from '@/components/footer'
import VueLazyLoad from 'vue-lazyload'

Vue.use(VueRouter)
Vue.component('pc-header', pcHeader)
Vue.component('pc-footer', pcFooter)
Vue.use(VueLazyLoad)

Vue.use(VueLazyLoad, {
  preLoad: 1.3,
  attempt: 1,
})
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../src/views/home.vue'),
    meta: { title: '首页' },
  },
  //关于我们
  {
    path: '/aboutus',
    name: 'AboutUs',
    component: () => import('../src/views/aboutus/AboutNavLayout.vue'),
    redirect: { name: 'Introduce' },

    children: [
      {
        path: 'introduce',
        name: 'Introduce',
        meta: { title: '关于我们' },
        component: () => import('../src/views/aboutus/Introduce.vue'),
      },
      {
        path: 'develophistory',
        name: 'DevelopmentHistory',
        component: () => import('../src/views/aboutus/DevelopmentHistory.vue'),
      },
      {
        path: 'certificatehonor',
        name: 'CertificateHonor',
        component: () => import('../src/views/aboutus/CertificateHonor.vue'),
      },
      {
        path: 'solution',
        name: 'IndstrySolution',
        component: () => import('../src/views/aboutus/IndstrySolution.vue'),
      },
    ],
  },
  //  产品介绍
  {
    path: '/product',
    name: 'ProductIndtoduce',
    component: () => import('../src/views/indtoduce/ProductIndtoduce.vue'),
    meta: {
      title: '产品介绍',
    },
  },
  // Business
  {
    path: '/business',
    name: 'Business',
    component: () =>
      import('../src/views/businessmovement/BusinesstNavLayout.vue'),
    redirect: { name: 'About1' },

    children: [
      {
        path: 'about',
        name: 'About1',
        meta: { title: '企业动态' },
        component: () =>
          import('../src/views/businessmovement/movement/About.vue'),
      },
      {
        path: 'conact',
        name: 'Conact1',
        component: () =>
          import('../src/views/businessmovement/movement/Conact.vue'),
      },
      {
        path: 'problem',
        name: 'problem1',
        component: () =>
          import('../src/views/businessmovement/movement/problem.vue'),
      },
      {
        path: 'knowledge',
        name: 'knowledge1',
        component: () =>
          import('../src/views/businessmovement/movement/knowledge.vue'),
      },
    ],
  },

  // ConnectUs
  {
    path: '/connectus',
    name: 'ConnectUs',
    component: () => import('../src/views/ConnectUs.vue'),
    meta: {
      title: '联系我们',
    },
  },
  // 企业公告 start
  {
    path: '/news1',
    name: 'News1',
    component: () => import('../src/views/news/news/news1.vue'),
  },
  {
    path: '/news2',
    name: 'News2',
    component: () => import('../src/views/news/news/news2.vue'),
  },
  {
    path: '/news3',
    name: 'News3',
    component: () => import('../src/views/news/news/news3.vue'),
  },
  {
    path: '/news4',
    name: 'News4',
    component: () => import('../src/views/news/news/news4.vue'),
  },
  {
    path: '/news5',
    name: 'News5',
    component: () => import('../src/views/news/news/news5.vue'),
  },
  {
    path: '/news6',
    name: 'News6',
    component: () => import('../src/views/news/news/news6.vue'),
  },
  // 新闻动态部分 start
  {
    path: '/dynamic1',
    name: 'Dynamic1',
    component: () => import('../src/views/news/dynamic/dynamic1.vue'),
  },
  {
    path: '/dynamic2',
    name: 'Dynamic2',
    component: () => import('../src/views/news/dynamic/dynamic2.vue'),
  },
  {
    path: '/dynamic3',
    name: 'Dynamic3',
    component: () => import('../src/views/news/dynamic/dynamic3.vue'),
  },
  {
    path: '/dynamic4',
    name: 'Dynamic4',
    component: () => import('../src/views/news/dynamic/dynamic4.vue'),
  },
  {
    path: '/dynamic5',
    name: 'Dynamic5',
    component: () => import('../src/views/news/dynamic/dynamic5.vue'),
  },
  {
    path: '/dynamic6',
    name: 'Dynamic6',
    component: () => import('../src/views/news/dynamic/dynamic6.vue'),
  },
  // 常见问题部分 start
  {
    path: '/newsproblem1',
    name: 'Newsproblem1',
    component: () => import('../src/views/news/problem/newsproblem1.vue'),
  },
  {
    path: '/newsproblem2',
    name: 'Newsproblem2',
    component: () => import('../src/views/news/problem/newsproblem2.vue'),
  },
  {
    path: '/newsproblem3',
    name: 'Newsproblem3',
    component: () => import('../src/views/news/problem/newsproblem3.vue'),
  },
  {
    path: '/newsproblem4',
    name: 'Newsproblem4',
    component: () => import('../src/views/news/problem/newsproblem4.vue'),
  },
  {
    path: '/newsproblem5',
    name: 'Newsproblem5',
    component: () => import('../src/views/news/problem/newsproblem5.vue'),
  },
  {
    path: '/newsproblem6',
    name: 'Newsproblem6',
    component: () => import('../src/views/news/problem/newsproblem6.vue'),
  },
  // 知识拓展部分 start
  {
    path: '/newknowledge1',
    name: 'Newknowledge1',
    component: () => import('../src/views/news/knowledge/newknowledge1.vue'),
  },
  {
    path: '/newknowledge2',
    name: 'Newknowledge2',
    component: () => import('../src/views/news/knowledge/newknowledge2.vue'),
  },
  {
    path: '/newknowledge3',
    name: 'Newknowledge3',
    component: () => import('../src/views/news/knowledge/newknowledge3.vue'),
  },
  {
    path: '/newknowledge4',
    name: 'Newknowledge4',
    component: () => import('../src/views/news/knowledge/newknowledge4.vue'),
  },
  {
    path: '/newknowledge5',
    name: 'Newknowledge5',
    component: () => import('../src/views/news/knowledge/newknowledge5.vue'),
  },
  {
    path: '/newknowledge6',
    name: 'Newknowledge6',
    component: () => import('../src/views/news/knowledge/newknowledge6.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
